import React, { useEffect, useState } from "react";
import Slider from "react-slick";

import SectionTitle from "../../components/SectionTitle";
import SingleTestimonial from "../../components/Testimonial/SingleTestimonial";

import comaImg from "../../assets/images/testimonial/coma.png";
import { SERVER_URL } from "../../api/url";
import axios from "axios";

const Testimonial = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchReview();
  }, []);

  const fetchReview = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/student/students`);
      const fetchedData = response.data?.data || [];
      setData(fetchedData);
    
    } catch (err) {
      console.error(err.response);
     
    } finally {
      setLoading(false);
    }
  };

  const testimonialSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="react-clients react-clientso home-testimonial pt---90 pb---120">
      <div className="container">
        <SectionTitle Title="What our students are saying" />
        <div
          className="client-slider wow animate__fadeInUp"
          data-wow-duration="0.3s"
        >
          <Slider {...testimonialSettings}>
            {!loading && data.map((item, index) => {
              return (
                <SingleTestimonial
                  key={index}
                  itemClass="single-client"
                  itemImg={`https://back.yourfrenchteachers.com/${item.image}`}
                  Title={item.name}
                  Designation={`${item.role} Student`}
                  Desc={item.description}
                  ratingCount={item.rate || 4.9} // Ensure a default rating
                  reviewCount={Math.floor(item.rate) || 4} // Ensure a default review count
                  comaImg={comaImg}
                />
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
